import { CircularProgress, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import UsuarioStore from './store/UsuarioStore';
import ParametroStore from './store/ParametroStore';
import RouterStore from './store/RouterStore';

interface IPropsRota {
    permissao?: string[];
    element: JSX.Element;
    params?: any;
}


const Rota = observer(({ permissao, element, params }: IPropsRota) => {
    const routeParams = useParams();
    const parametrosRota = params || routeParams;

    const temPermissao =
        !permissao || permissao.some((p) => UsuarioStore.usuarioTemPapel(p));

    RouterStore.setParams(parametrosRota);

    if (!temPermissao) {
        return <Typography>Usuário sem permissão de acesso</Typography>;
    }

    // O escaninho de pauta ainda é restrito às unidades parametrizadas no sistema.
    if (parametrosRota?.tipo === 'pauta' && !ParametroStore.escaninhoPautaHabilitado) {
        if (!ParametroStore.parametrosCarregados) {
            return <CircularProgress />;
        }
        return <Typography>Escaninho de Pauta não disponível para a sua unidade</Typography>;
    }

    return element ?? null;
});

export default Rota;
